import { track } from 'utils/tracking';
import { ITrackingProductPageBaseParameters } from '../shared/baseParameters';
import { fillItems, ITrackingFillItemsParameters } from '../shared/fillItems';
import {
  fillRewardCampaign,
  ITrackingFillRewardCampaignParameters,
} from '../shared/fillRewardCampaign';

export const trackQAExpandOrCollapse = (
  parameters: {
    componentTitle: string;
    isCollapsed: boolean;
  } & Pick<ITrackingProductPageBaseParameters, 'leadId'> &
    ITrackingFillItemsParameters &
    ITrackingFillRewardCampaignParameters,
): void => {
  const { componentTitle, isCollapsed, leadId } = parameters;

  return track({
    event: 'product_interaction',
    component_type: 'faq',
    component_title: `Q&A_${componentTitle}`,
    action: isCollapsed ? 'collapse' : 'expand',
    item_list_name: 'apply form',
    ...fillItems(parameters),
    step_number: '1',
    step_name: 'lead-submission',
    lead_id: leadId,
    ...fillRewardCampaign(parameters),
  });
};
